import * as React from 'react';
import 'moment/locale/fr';
import Page from 'src/presentations/views/PageView';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { defaults } from 'react-chartjs-2';
import { multipleQueries } from 'src/utils/graph/GraphExplorer';
import { register } from 'timeago.js';
import { localeENFunc } from 'src/utils/timeago';
import withSession from 'src/utils/withSession';
import * as SC from "../../companies/Company_styled";
import Scrollbars from 'react-custom-scrollbars';
import DeleteModal from 'src/presentations/widgets/DeleteModal'
import { toast } from "react-toastify";
import { Storage } from 'src/utils/storage'
import Loader from 'src/presentations/widgets/Loader';
import { translate } from 'src/utils/translate';
register('en', localeENFunc);
defaults.global.defaultFontFamily = 'Gelion';
import Text from 'src/presentations/elements/Text';
import { useHistory, useLocation } from "react-router-dom";
import { signS3URLGet } from 'src/utils/graph';
import i18n from 'src/assets/messages';
import styled from 'styled-components';
import { CloudRain } from 'react-feather';
import Table from 'src/presentations/collections/Table/Columns';
import { IUserCompany } from 'src/pages/companies/createCompany';
import * as moment from 'moment';
import { parse } from "query-string";

export type Cell = string | number | undefined;

const StyledTable = styled.div`
  .table-simple td {
    vertical-align: middle !important;
    padding: 5px 10px !important;
    border-bottom: 1px solid #fff;
  }
`;

export interface Row {
    statusCode: number;
    value: string;
    type: string;
}
interface PropsInterface extends RouteComponentProps<{}> {
    session: any;
}

export interface IcompaniesRows {
    name: string
    description: string
    task: string
    logoURL: string
    color: string
    id: string
    companyUsers: IUserCompany[]
}

const Documents = (props: PropsInterface) => {
    const { search } = useLocation()

    const [showModal, setshowModal] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [ElementId,] = React.useState<string>("");
    const [companiesRows, setDocuments] = React.useState<IcompaniesRows[]>([]);
    const [, setUser] = React.useState({ admin: false });
    const { push, location } = useHistory();
    const queryURL = new URLSearchParams(search)
    const [ready] = React.useState(true);
    const { companyId }: any = useParams()
    const [pages, setPage] = React.useState(Number(queryURL.get('page')) ? Number(queryURL.get('page')) : 1);
    const [docCount, setDocCount] = React.useState(0)

    const language = Storage.get('language')

    const paramsDefault = {
        noDataIndication: i18n.t('resultEmptyExtenxion'),
        containerClass: 'table-simple table-simple-raw',
        bordered: false,
        striped: false,
        hover: false,
        rowClasses: 'listRow',
    };

    React.useEffect(() => {
        document.title = `Documents`;
        getData();
    }, [pages])


    const getData = async () => {
        setLoading(true)
        const prms: any = parse(location.search);

        let offset;
        if (prms.page) {
        offset = ((prms.page || 1) - 1) * 30;
        }
        const meCurrent = Storage.get('meCurrent')
        const result: any = await multipleQueries([
            {
                type: "findAll",
                target: 'BankDocument',
                alias: 'rows',
                order: [['date', 'DESC']],
                where: { companyId },
                offset,
                limit: 30,
                output: {
                    id: true,
                    date: true,
                    powensId: true,
                    filename: true,
                    createdAt: true,
                },
            },
            {
                type: "count",
                target: 'BankDocument',
                alias: 'documentCount',
                where: { companyId }
            },
            {
                type: "findOne",
                target: 'user',
                alias: 'user',
                id: meCurrent?.user?.id,
                output: {
                    id: true,
                    admin: true,
                    accountId: true
                },
            },
            {
                type: 'findOne',
                target: 'Account',
                alias: 'trialperiod',
                where: { id: meCurrent?.account?.id },
                output: {
                    id: true,
                    createdAt: true,
                    status: true,
                    planType: true,
                    customActivate: true,
                    accountVerified: true,
                }
            }
        ]);

        const DateObj = new Date(result.trialperiod.createdAt)
        DateObj.setDate(DateObj.getDate() + 15)
        setUser(result.user)
        setDocuments(result.rows)
        setLoading(false)
        setDocCount(result.documentCount)
    }

    const handlePageChange: any = (pageNumber: number) => {
        const currentUrlParams = new URLSearchParams(location.search);
        if (pageNumber) {
            currentUrlParams.set('page', pageNumber.toString());
            setPage(Number(pageNumber));
            push(location.pathname + "?" + currentUrlParams.toString());
        }
    };

    const deleteModal = async () => {
        setshowModal(false);
        await getData();
        toast(translate(language, 'Company deleted!'), { autoClose: 2000 })
    }

    const datalink = async (ZipFileName: any) => {
        const bucket = "wikitoria-inference";
        const signedRes = await (signS3URLGet as any)({ key: `releves/${ZipFileName}`, name: ZipFileName, bucket });
        window.open(signedRes.signedUrl, "_blank")
    }

    const columnsModels = () => [
        {
            dataField: 'filename',
            text: 'Nom du document',
            headerStyle: { width: '50%' },
            formatter: (cell: Cell, row: any) => {
                return (
                    <a onClick={() => datalink(cell)}>
                        <Text useWordBoundary={100} trucanteType="middle">{decodeURIComponent(String(cell))}</Text>
                    </a>
                )
            }
        },

        {
            dataField: 'date',
            text: translate(language, 'Date du relevé bancaire'),
            headerStyle: { width: '30%' },
            formatter: (cell: any, row: any) => {
                return (<span>
                    {`${moment(new Date(cell)).locale(language).format('DD/MM/YYYY')}`}
                </span>)
            }
        },

        {
            dataField: 'filename',
            text: '',
            headerStyle: { width: '15%' },
            formatter: (cell: Cell, row: any) => {
                return (
                    <a onClick={() => datalink(cell)}>
                        <CloudRain size="15" style={{ verticalAlign: "sub", marginRight: 5 }} />
                        <Text useWordBoundary={100} trucanteType="middle">{translate(language, 'Télécharger le relevé')}</Text>
                    </a>
                )
            }
        },
    ];

    return (
        <SC.StyleCompany>
            <div className="companyWrap" style={{ paddingTop: 15 }}>
                <DeleteModal
                    show={showModal}
                    onHide={() => setshowModal(false)}
                    target="Company"
                    id={ElementId}
                    onComfirm={deleteModal}
                />
                <div
                    className="well"
                    style={{
                    marginBottom: "30px",
                    marginLeft: "30px",
                    marginRight: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    }}
                >
                    <span className="total-data">Total documents: {docCount}</span>
                </div>
                <Page.Content>
                    {loading && (
                        <Loader textLabel={translate(language, "Chargement des relevés bancaires")} />
                    )}
                    {!loading && (
                        <Scrollbars style={{ height: 'calc(90vh - 175px)', width: "calc(100% )" }} autoHide={true}>
                            <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                                <StyledTable>
                                    <Table
                                        {...paramsDefault}
                                        ready={ready}
                                        loading={loading}
                                        datas={companiesRows || []}
                                        columns={(columnsModels()) as any}
                                        selectColumn={false}
                                        pagination={{
                                            page: pages,
                                            sizePerPage: 30,
                                            onPageChange: handlePageChange,
                                            alwaysShowAllBtns: false,
                                        }}
                                        totalSize={docCount}
                                        striped={true}
                                        noDataIndication={(translate(language, 'No requests available'))}
                                        hover={true}
                                    />
                                </StyledTable>
                            </div>
                        </Scrollbars>
                    )}
                </Page.Content>
            </div>
        </SC.StyleCompany>
    );
}

export default withSession(Documents);


// WEBPACK FOOTER //
// ./src/pages/company/documents/index.tsx